import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import './DacRegisterForm.css';
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { get, getDictionaryItem, canUseDOM } from '../../../utils';
import { validateRequired, runValidations, validatePassword, validateRequiredCheckbox, validateEmailRegex, validateLettersOnly, validateMaxLength, validateMinLength, validateAlphaNumericUsername, validatNumericRegex, validateLength } from '../../Login/commomFunctions';
import FormField from '../../Login/components/FormField';
import Password from '../../Login/components/Password';
import Checkboxes from '../../Login/components/Checkboxes';
import DateField from '../../DAcApplication/components/StepsTemplates/components/FormFields/Date';
import Loader from '../../DAcApplication/components/loader';
import { getSessionId } from '../../DAcApplication/utils';
import Modal from './Modal';
import RegistrationInvitationCode from './InvitationCode/RegistrationInvitationCode';
import InjectHTML from './InjectHTML';
import IconVerified from './icon/verified';
import { AGE_LIMIT, OTP_RESEND_DELAY } from './constants';
import { uploadConsent } from '../../DAcApplication/components/actions';
var DacRegisterForm = function DacRegisterForm(_ref) {
  var dictionary = _ref.dictionary,
    configuration = _ref.configuration,
    apiConfig = _ref.apiConfig,
    fieldsParams = _ref.fieldsParams;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    disableSubmit = _useState2[0],
    setDisableSubmit = _useState2[1];
  var sessionId = getSessionId('register');
  var usernameMaxLength = fieldsParams && fieldsParams.usernameMaxLength ? fieldsParams.usernameMaxLength : 20;
  var usernameMinLength = fieldsParams && fieldsParams.usernameMinLength ? fieldsParams.usernameMinLength : 3;
  var firstNameMaxLength = fieldsParams && fieldsParams.firstNameMaxLength ? fieldsParams.firstNameMaxLength : 50;
  var firstNameMinLength = fieldsParams && fieldsParams.firstNameMinLength ? fieldsParams.firstNameMinLength : 2;
  var lastNameMaxLength = fieldsParams && fieldsParams.lastNameMaxLength ? fieldsParams.lastNameMaxLength : 50;
  var lastNameMinLength = fieldsParams && fieldsParams.lastNameMinLength ? fieldsParams.lastNameMinLength : 2;
  var otpRequiredLength = fieldsParams && fieldsParams.otpRequiredLength ? fieldsParams.otpRequiredLength : 6;
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    username = _useState4[0],
    setUsername = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorUsername = _useState6[0],
    setErrorUsername = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    usernameAvailable = _useState8[0],
    setUsernameAvailable = _useState8[1];
  var usernameFieldProps = {
    value: username,
    fieldError: errorUsername,
    setError: setErrorUsername,
    label: getDictionaryItem(dictionary, 'username'),
    type: 'text',
    id: 'RegisterUsername',
    name: 'RegisterUsername',
    placeholder: '',
    labelLight: false,
    errorRequired: getDictionaryItem(dictionary, 'usernameRequired') || ' ',
    errorTaken: getDictionaryItem(dictionary, 'usernameisTaken'),
    autoComplete: 'username',
    required: true,
    requiredFromContent: true,
    maxLength: usernameMaxLength,
    errorMaxLength: getDictionaryItem(dictionary, 'usernameMaxLengthError') || ' ',
    minLength: usernameMinLength,
    errorMinLength: getDictionaryItem(dictionary, 'usernameMinLengthError') || ' ',
    errorValue: getDictionaryItem(dictionary, 'usernameInvalid') || ' ',
    changeEvent: function changeEvent(value) {
      setUsername(value);
      setUsernameAvailable(false);
      setIsSendOTP(false);
      setCodeOTP('');
      setValiadteError('');
    },
    blurEvent: function blurEvent(value) {
      usernameFieldProps.validate(value);
    },
    validate: function validate() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : username;
      var validationResult = runValidations([validateRequired, validateMaxLength, validateMinLength, validateAlphaNumericUsername], value, usernameFieldProps);
      return validationResult;
    }
  };
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    firstname = _useState10[0],
    setFirstname = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    errorFirstname = _useState12[0],
    setErrorFirstname = _useState12[1];
  var firstnameFieldProps = {
    value: firstname,
    fieldError: errorFirstname,
    setError: setErrorFirstname,
    label: getDictionaryItem(dictionary, 'firstName'),
    type: 'text',
    id: 'RegisterFirstname',
    name: 'RegisterFirstname',
    placeholder: '',
    labelLight: false,
    errorRequired: getDictionaryItem(dictionary, 'firstNameRequired') || ' ',
    errorValue: getDictionaryItem(dictionary, 'firstNameInvalid') || ' ',
    autoComplete: 'given-name',
    required: true,
    requiredFromContent: true,
    maxLength: firstNameMaxLength,
    errorMaxLength: getDictionaryItem(dictionary, 'firstnameMaxLengthError') || ' ',
    minLength: firstNameMinLength,
    errorMinLength: getDictionaryItem(dictionary, 'firstnameMinLengthError') || ' ',
    changeEvent: function changeEvent(value) {
      setFirstname(value);
    },
    blurEvent: function blurEvent(value) {
      firstnameFieldProps.validate(value);
    },
    validate: function validate() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : firstname;
      return runValidations([validateRequired, validateLettersOnly, validateMaxLength, validateMinLength], value, firstnameFieldProps);
    }
  };
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    lastname = _useState14[0],
    setLastname = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    errorLastname = _useState16[0],
    setErrorLastname = _useState16[1];
  var lastnameFieldProps = {
    value: lastname,
    fieldError: errorLastname,
    setError: setErrorLastname,
    label: getDictionaryItem(dictionary, 'lastName'),
    type: 'text',
    id: 'RegisterLastname',
    name: 'RegisterLastname',
    placeholder: '',
    labelLight: false,
    errorRequired: getDictionaryItem(dictionary, 'lastNameRequired') || ' ',
    errorValue: getDictionaryItem(dictionary, 'lastNameNameInvalid') || ' ',
    autoComplete: 'family-name',
    required: true,
    requiredFromContent: true,
    maxLength: lastNameMaxLength,
    errorMaxLength: getDictionaryItem(dictionary, 'lastnameMaxLengthError') || ' ',
    minLength: lastNameMinLength,
    errorMinLength: getDictionaryItem(dictionary, 'lastnameMinLengthError') || ' ',
    changeEvent: function changeEvent(value) {
      setLastname(value);
    },
    blurEvent: function blurEvent(value) {
      lastnameFieldProps.validate(value);
    },
    validate: function validate() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : lastname;
      return runValidations([validateRequired, validateLettersOnly, validateMaxLength, validateMinLength], value, lastnameFieldProps);
    }
  };
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    password = _useState18[0],
    setPassword = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    errorPassword = _useState20[0],
    setErrorPassword = _useState20[1];
  var passwordFieldProps = {
    value: password,
    fieldError: errorPassword,
    setError: setErrorPassword,
    label: getDictionaryItem(dictionary, 'password'),
    type: 'password',
    id: 'RegisterPassword',
    name: 'RegisterPassword',
    placeholder: '',
    labelLight: false,
    passLink: null,
    errorRequired: getDictionaryItem(dictionary, 'passwordRequired') || ' ',
    errorValue: getDictionaryItem(dictionary, 'passwordIsNotValid') || ' ',
    autoComplete: 'off',
    required: true,
    requiredFromContent: true,
    changeEvent: function changeEvent(value) {
      setPassword(value);
    },
    blurEvent: function blurEvent(value) {
      passwordFieldProps.validate(value);
    },
    validate: function validate() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : password;
      return runValidations([validateRequired, validatePassword, validateMatchPasswordParent], value, passwordFieldProps);
    }
  };
  var _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    confirmPassword = _useState22[0],
    setConfirmPassword = _useState22[1];
  var _useState23 = useState(''),
    _useState24 = _slicedToArray(_useState23, 2),
    errorConfirmPassword = _useState24[0],
    setErrorConfirmPassword = _useState24[1];
  var confirmPasswordFieldProps = {
    value: confirmPassword,
    fieldError: errorConfirmPassword,
    setError: setErrorConfirmPassword,
    label: getDictionaryItem(dictionary, 'confirmPassword'),
    type: 'password',
    id: 'RegisterConfirmPassword',
    name: 'RegisterConfirmPassword',
    placeholder: '',
    labelLight: false,
    passLink: null,
    errorRequired: getDictionaryItem(dictionary, 'confirmPasswordRequired') || ' ',
    errorMatchChild: getDictionaryItem(dictionary, 'passwordValidationError') || ' ',
    autoComplete: 'off',
    required: true,
    requiredFromContent: true,
    changeEvent: function changeEvent(value) {
      setConfirmPassword(value);
    },
    blurEvent: function blurEvent(value) {
      confirmPasswordFieldProps.validate(value);
    },
    validate: function validate() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : confirmPassword;
      return runValidations([validateRequired, validateMatchPasswordChild], value, confirmPasswordFieldProps);
    }
  };
  var validateMatchPasswordChild = function validateMatchPasswordChild(value, fieldObj) {
    if (value === password) {
      fieldObj.setError('');
      return true;
    } else {
      fieldObj.setError(fieldObj.errorMatchChild);
      return false;
    }
  };
  var validateMatchPasswordParent = function validateMatchPasswordParent(value, fieldObj) {
    if (value === confirmPassword) {
      setErrorConfirmPassword('');
      return true;
    } else {
      //   setErrorConfirmPassword(errorMatchConfirmPassword);
      return false;
    }
  };
  var _useState25 = useState(''),
    _useState26 = _slicedToArray(_useState25, 2),
    email = _useState26[0],
    setEmail = _useState26[1];
  var _useState27 = useState(''),
    _useState28 = _slicedToArray(_useState27, 2),
    errorEmail = _useState28[0],
    setErrorEmail = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    emailAvailable = _useState30[0],
    setEmailAvailable = _useState30[1];
  var emailFieldProps = {
    value: email,
    fieldError: errorEmail,
    setError: setErrorEmail,
    label: getDictionaryItem(dictionary, 'emailAddress'),
    type: 'email',
    id: 'RegisterEmail',
    name: 'RegisterEmail',
    placeholder: '',
    labelLight: false,
    // maxLength: defaultMaxLength,
    errorRequired: getDictionaryItem(dictionary, 'emailRequired') || ' ',
    errorValue: getDictionaryItem(dictionary, 'emailIsNotValid') || ' ',
    errorValidation: getDictionaryItem(dictionary, 'emailValidationError'),
    successValidation: getDictionaryItem(dictionary, 'emailValidationSuccess'),
    autoComplete: 'email',
    required: true,
    requiredFromContent: true,
    changeEvent: function changeEvent(value) {
      setEmail(value);
      setIsSendOTP(false);
      setCodeOTP('');
      setValiadteError('');
    },
    blurEvent: function blurEvent(value) {
      emailFieldProps.validate(value);
    },
    validate: function validate() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : email;
      return runValidations([validateRequired, validateEmailRegex], value, emailFieldProps);
    }
    // focusEvent: formFillAnalytics
  };
  var _useState31 = useState(''),
    _useState32 = _slicedToArray(_useState31, 2),
    dateOfBirth = _useState32[0],
    setDateOfBirth = _useState32[1];
  var _useState33 = useState(''),
    _useState34 = _slicedToArray(_useState33, 2),
    errorDateOfBirth = _useState34[0],
    setErrorDateOfBirth = _useState34[1];
  // const [validateDateOfBirth, setValidateDateOfBirth] = useState(false);
  var dateOfBirthRequired = getDictionaryItem(dictionary, 'dateOfBirthRequired') || ' ';
  var ageIsNotValid = getDictionaryItem(dictionary, 'ageValidationMessage') || ' ';
  var dateOfBirthFieldProps = {
    value: '',
    name: 'RegisterDateOfBirth',
    patternInvalidMessage: errorDateOfBirth,
    required: true,
    validate: true,
    ageLimit: AGE_LIMIT,
    isOnlyPast: true,
    updateContext: function updateContext(obj) {
      var val = obj.RegisterDateOfBirth.value;
      var ageInvalid = obj.RegisterDateOfBirth.ageInvalid;
      setDateOfBirth(val);
      if (ageInvalid) {
        setErrorDateOfBirth(ageIsNotValid);
      } else {
        setErrorDateOfBirth('');
      }
    },
    blurEvent: function blurEvent(value) {
      if (!value) validateDateOfBirthRequired(value);
    }
  };
  var validateDateOfBirthRequired = function validateDateOfBirthRequired(value) {
    value = value.trim();
    if (value.length) {
      setErrorDateOfBirth('');
      return false;
    } else {
      setErrorDateOfBirth(dateOfBirthRequired);
      return true;
    }
  };
  var _useState35 = useState([{
      name: 'RegisterEmailMarketing',
      id: 'RegisterEmailMarketing',
      value: false,
      label: get(configuration, 'acceptEmailOrMessagesText.jss.value'),
      required: false
    }, {
      name: 'RegisterPrivacyPolicy',
      id: 'RegisterPrivacyPolicy',
      value: false,
      label: get(configuration, 'acceptDGDPRAndPrivacyPolicyText.jss.value'),
      childrenHTML: /*#__PURE__*/React.createElement(InjectHTML, {
        htmlString: get(configuration, "acceptDGDPRAndPrivacyPolicyText.jss.value")
      }),
      required: true
      //   errorRequired: errorRequiredPrivacyPolicy,
    }]),
    _useState36 = _slicedToArray(_useState35, 2),
    checkboxes = _useState36[0],
    setCheckboxes = _useState36[1];
  var _useState37 = useState(''),
    _useState38 = _slicedToArray(_useState37, 2),
    errorCheckboxes = _useState38[0],
    setErrorCheckboxes = _useState38[1];
  var checkboxesFieldProps = {
    checkboxes: checkboxes,
    fieldError: errorCheckboxes,
    setError: setErrorCheckboxes,
    errorRequired: '',
    changeEvent: function changeEvent(name, value) {
      var checkboxesCopy = checkboxes;
      checkboxesCopy = checkboxesCopy.filter(function (item) {
        if (item.name === name) {
          item.value = value;
        }
        return item;
      });
      setCheckboxes(checkboxesCopy);
      checkboxesFieldProps.validate();
      //   formFillAnalytics();
    },
    validate: function validate() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkboxes;
      return runValidations([validateRequiredCheckbox], value, checkboxesFieldProps);
    }
  };
  useEffect(function () {
    if (email && !errorEmail && username && !errorUsername) {
      setIsDisableOTP(false);
    } else {
      setIsDisableOTP(true);
    }
  }, [email, errorEmail, username, errorUsername]);

  // OTP
  var _useState39 = useState(true),
    _useState40 = _slicedToArray(_useState39, 2),
    isDisableOTP = _useState40[0],
    setIsDisableOTP = _useState40[1];
  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    isSendOTP = _useState42[0],
    setIsSendOTP = _useState42[1];
  var _useState43 = useState(false),
    _useState44 = _slicedToArray(_useState43, 2),
    isResendOTP = _useState44[0],
    setIsResendOTP = _useState44[1];
  var sendVerifyCode = function sendVerifyCode(url) {
    var resend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (resend) {
      setIsSendOTP(false);
      setIsResendOTP(false);
      clearTimeout(resendTimer);
      setCodeOTP('');
      setSubmitError('');
    }
    validateUserRegistrationWithEmail();
  };
  var _useState45 = useState(''),
    _useState46 = _slicedToArray(_useState45, 2),
    otpPublicID = _useState46[0],
    setOtpPublicID = _useState46[1];
  var _useState47 = useState(false),
    _useState48 = _slicedToArray(_useState47, 2),
    validateLoader = _useState48[0],
    setValidateLoader = _useState48[1];
  var _useState49 = useState(''),
    _useState50 = _slicedToArray(_useState49, 2),
    valiadteError = _useState50[0],
    setValiadteError = _useState50[1];
  var resendTimer = null;
  var validateUserRegistrationWithEmail = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var url, headers, data, requestOptions;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setValidateLoader(true);
            setValiadteError('');
            url = "".concat(apiConfig.apiUrl, "/v1/proxy/user/register/validate");
            headers = new Headers();
            headers.append('X-Request-Id', sessionId);
            headers.append('Apikey', apiConfig.apiKey);
            headers.append('Accept', 'application/json');
            headers.append('Content-Type', 'application/json');
            headers.append('Access-Control-Allow-Methods', 'GET,HEAD,POST,OPTIONS');
            headers.append('Access-Control-Allow-Origin', '*');
            data = {
              RegistrationType: 2,
              ValidateUserRegistrationByEMail: {
                username: username,
                email: email
              }
            };
            requestOptions = {
              method: 'POST',
              headers: headers,
              body: JSON.stringify(data)
            };
            _context.next = 14;
            return fetch(url, requestOptions).then(function (response) {
              return response.json();
            }).then(function (result) {
              if (result.hasOwnProperty('desc')) {
                setValiadteError(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
              }
              if (result.hasOwnProperty('Result')) {
                setIsSendOTP(result.Result.Status);
                setUsernameAvailable(result.Result.Status);
                setEmailAvailable(result.Result.Status);
                setOtpPublicID(result.OTPPublicID);
                resendTimer = setTimeout(function () {
                  setIsResendOTP(true);
                  clearTimeout(resendTimer);
                }, OTP_RESEND_DELAY * 60000);
              }
            }).catch(function (error) {
              setValiadteError(error.message);
              console.error('validateUserRegistrationWithEmail error', error);
            }).finally(function () {
              return setValidateLoader(false);
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function validateUserRegistrationWithEmail() {
      return _ref2.apply(this, arguments);
    };
  }();
  var _useState51 = useState(''),
    _useState52 = _slicedToArray(_useState51, 2),
    codeOTP = _useState52[0],
    setCodeOTP = _useState52[1];
  var _useState53 = useState(''),
    _useState54 = _slicedToArray(_useState53, 2),
    errorCodeOTP = _useState54[0],
    setErrorCodeOTP = _useState54[1];
  var codeOTPFieldProps = {
    value: codeOTP,
    fieldError: errorCodeOTP,
    setError: setErrorCodeOTP,
    label: getDictionaryItem(dictionary, 'otpLabel'),
    type: 'password',
    id: 'RegisterEnterOTP',
    name: 'RegisterEnterOTP',
    placeholder: '',
    labelLight: false,
    passLink: null,
    errorRequired: getDictionaryItem(dictionary, 'otpRequired') || ' ',
    required: true,
    requiredFromContent: true,
    autoComplete: 'off',
    requiredLength: otpRequiredLength,
    errorValue: getDictionaryItem(dictionary, 'otpIsNotValid') || ' ',
    changeEvent: function changeEvent(value) {
      setCodeOTP(value);
    },
    blurEvent: function blurEvent(value) {
      codeOTPFieldProps.validate(value);
    },
    validate: function validate() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : codeOTP;
      return runValidations([validateRequired, validatNumericRegex, validateLength], value, codeOTPFieldProps);
    }
  };
  var _useState55 = useState(false),
    _useState56 = _slicedToArray(_useState55, 2),
    verifyCode = _useState56[0],
    setverifyCode = _useState56[1];
  var checkVerifyCode = function checkVerifyCode() {
    try {
      // fetch data
      // setverifyCode(true);
    } catch (error) {}
  };
  var _useState57 = useState(false),
    _useState58 = _slicedToArray(_useState57, 2),
    verifyLoader = _useState58[0],
    setVerifyLoader = _useState58[1];

  // form submit
  var _useState59 = useState(''),
    _useState60 = _slicedToArray(_useState59, 2),
    submitError = _useState60[0],
    setSubmitError = _useState60[1];
  var urlRedirect = get(configuration, 'registerAndLoginButton.jss.value.href');
  var formSubmit = function formSubmit(event) {
    event.preventDefault();
    submitUserRegistrationWithEmail();
    // setShowModal(true);
  };
  var _useState61 = useState(0),
    _useState62 = _slicedToArray(_useState61, 2),
    submitLoader = _useState62[0],
    setSubmitLoader = _useState62[1];
  var submitUserRegistrationWithEmail = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var url, apiKey, headers, data, requestOptions;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setSubmitLoader(function (prev) {
              return prev + 1;
            });
            setSubmitError('');
            url = "".concat(apiConfig.apiUrl, "/v1/proxy/user/register");
            apiKey = apiConfig.apiKey || '';
            headers = new Headers();
            headers.append('X-Request-Id', sessionId);
            headers.append('Apikey', apiKey);
            headers.append('Accept', 'application/json');
            headers.append('Content-Type', 'application/json');
            headers.append('Access-Control-Allow-Methods', 'GET,HEAD,POST,OPTIONS');
            headers.append('Access-Control-Allow-Origin', '*');
            data = {
              RegistrationType: 2,
              UserRegistrationByEMail: {
                username: username,
                email: email,
                firstName: firstname,
                lastName: lastname,
                birthDate: dateOfBirth,
                password: password,
                otp: codeOTP,
                otpPublicId: otpPublicID
              }
            };
            requestOptions = {
              method: 'POST',
              headers: headers,
              body: JSON.stringify(data)
            };
            _context2.next = 15;
            return fetch(url, requestOptions).then(function (response) {
              return response.json();
            }).then(function (result) {
              if (result.hasOwnProperty('desc')) {
                setSubmitError(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
              }
              if (result.hasOwnProperty('Result')) {
                Cookies.set('username', username, {
                  expires: 1,
                  secure: true
                });

                //call next step for getting token
                authorizeUser();
              }
            }).catch(function (error) {
              console.error('submitUserRegistrationWithEmail error', error);
              setSubmitError(error.message);
            }).finally(function () {
              return setSubmitLoader(function (prev) {
                return prev - 1;
              });
            });
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function submitUserRegistrationWithEmail() {
      return _ref3.apply(this, arguments);
    };
  }();
  var _useState63 = useState({}),
    _useState64 = _slicedToArray(_useState63, 2),
    tokenResult = _useState64[0],
    setTokenResult = _useState64[1];
  var authorizeUser = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var url, headers, data, requestOptions;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setSubmitLoader(function (prev) {
              return prev + 1;
            });
            url = "".concat(apiConfig.apiUrl, "/v1/proxy/individual/authenticate");
            headers = new Headers();
            headers.append('X-Request-Id', sessionId);
            headers.append('Apikey', apiConfig.apiKey);
            headers.append('Accept', 'application/json');
            headers.append('Content-Type', 'application/json');
            headers.append('Access-Control-Allow-Methods', 'GET,HEAD,POST,OPTIONS');
            headers.append('Access-Control-Allow-Origin', '*');
            data = {
              username: username,
              password: password
            };
            requestOptions = {
              method: 'POST',
              headers: headers,
              body: JSON.stringify(data)
            };
            _context3.next = 13;
            return fetch(url, requestOptions).then(function (response) {
              return response.json();
            }).then(function (result) {
              if (result.hasOwnProperty('desc')) {
                setSubmitError(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
              }
              if (result.hasOwnProperty('access_token')) {
                setTokenResult(result);
                // call next step for submitting invitation code
                // getUserStatus(); //run in useEffect
              }
            }).catch(function (error) {
              console.error('authorizeUser error', error);
            }).finally(function () {
              return setSubmitLoader(function (prev) {
                return prev - 1;
              });
            });
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function authorizeUser() {
      return _ref4.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (tokenResult.access_token) {
      getUserStatus();
    }
  }, [tokenResult]);
  var getUserStatus = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var url, headers, requestOptions;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            setSubmitLoader(function (prev) {
              return prev + 1;
            });
            url = "".concat(apiConfig.apiUrl, "/v1/orc/user/").concat(username, "/status");
            headers = new Headers();
            headers.append('X-Request-Id', sessionId);
            headers.append('Apikey', apiConfig.apiKey);
            headers.append('Accept', 'application/json');
            headers.append('Content-Type', 'application/json');
            headers.append('Authorization', "Bearer ".concat(tokenResult.access_token));
            headers.append('Host', 'dacqa.detsandbox.com');
            headers.append('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
            requestOptions = {
              method: 'GET',
              headers: headers,
              redirect: 'follow',
              keepalive: true,
              withCredentials: true
            };
            _context4.next = 13;
            return fetch(url, requestOptions).then(function (response) {
              if (response.status == 401) {}
              return response.json();
            }).then(function (result) {
              if (result.hasOwnProperty('desc')) {
                setSubmitError(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
                console.error(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
              }
              if (result.hasOwnProperty('status')) {
                if (result.status === false) {
                  setShowModal(true);
                } else {
                  callAfterSubmit();
                }
              }
            }).catch(function (error) {
              setSubmitError(error.message);
              console.error('User Status error', error);
            }).finally(function () {
              return setSubmitLoader(function (prev) {
                return prev - 1;
              });
            });
          case 13:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function getUserStatus() {
      return _ref5.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (username && !errorUsername && firstname && !errorFirstname && lastname && !errorLastname && password && !errorPassword && confirmPassword && !errorConfirmPassword && email && !errorEmail && dateOfBirth && !errorDateOfBirth && codeOTP && !errorCodeOTP && checkboxes.filter(function (item) {
      return item.required;
    }).every(function (item) {
      return item.value;
    }) && !errorCheckboxes) {
      setDisableSubmit(false);
      setSubmitError('');
    } else {
      setDisableSubmit(true);
    }
  }, [username, errorUsername, firstname, errorFirstname, lastname, errorLastname, password, errorPassword, confirmPassword, errorConfirmPassword, email, errorEmail, dateOfBirth, errorDateOfBirth, codeOTP, errorCodeOTP, checkboxes, errorCheckboxes]);
  var _useState65 = useState(false),
    _useState66 = _slicedToArray(_useState65, 2),
    showModal = _useState66[0],
    setShowModal = _useState66[1];
  useEffect(function () {
    if (showModal) {
      document.body.classList.add('prevent-scroll');
    } else {
      document.body.classList.remove('prevent-scroll');
    }
    return function () {
      document.body.classList.remove('prevent-scroll');
    };
  }, [showModal]);
  var redirectToUrl = function redirectToUrl(pathToRedirect) {
    if (canUseDOM) {
      window.location.href = pathToRedirect;
    }
  };
  var insertCookies = function insertCookies() {
    var expirationDate = new Date(tokenResult.expires_on).getTime();
    var currentDate = new Date().getTime();
    var daysUntilExpiration = Math.round((expirationDate - currentDate) / (1000 * 3600 * 24));
    Cookies.set('token', "Bearer ".concat(tokenResult.access_token), {
      expires: daysUntilExpiration,
      secure: true
    });
    Cookies.set('username', username, {
      expires: daysUntilExpiration,
      secure: true
    });
  };
  var callAfterSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var marketingCheckbox;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            marketingCheckbox = checkboxes.find(function (item) {
              return item.name === 'RegisterEmailMarketing';
            });
            _context5.next = 3;
            return uploadConsent({
              apiKey: apiConfig.apiKey,
              sessionId: sessionId
            }, {
              uuids: {
                email: String(email || '').toLocaleLowerCase()
              },
              activity_timestamp: Math.floor(Date.now() / 1000),
              consent_source: 'GDRFA Project',
              custom_parameters: {
                FirstName: firstname || '',
                LastName: lastname || '',
                FormURL: window.location.href || ''
              },
              consent_info: [{
                processing_purpose_id: 5,
                processing_purpose_name: 'Consent for marketing',
                consented_items: [{
                  consent_purpose_id: 6,
                  consent_granted: marketingCheckbox ? marketingCheckbox.value : false
                }]
              }]
            });
          case 3:
            insertCookies();
            redirectToUrl(urlRedirect);
          case 5:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function callAfterSubmit() {
      return _ref6.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("form", {
    className: "dac-login-form",
    onSubmit: function onSubmit(event) {
      return formSubmit(event);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row dac-login-form__inputs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap ".concat(errorUsername ? 'invalid-field' : '', " ").concat(usernameAvailable ? 'valid-field' : '')
  }, /*#__PURE__*/React.createElement(FormField, usernameFieldProps), usernameAvailable && /*#__PURE__*/React.createElement(CheckedIcon, null))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap ".concat(errorFirstname ? 'invalid-field' : '')
  }, /*#__PURE__*/React.createElement(FormField, firstnameFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap ".concat(errorLastname ? 'invalid-field' : '')
  }, /*#__PURE__*/React.createElement(FormField, lastnameFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group lr__form-group ".concat(errorDateOfBirth ? 'invalid-field' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-label"
  }, getDictionaryItem(dictionary, 'dateOfBirth')), /*#__PURE__*/React.createElement(DateField, dateOfBirthFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap ".concat(errorPassword ? 'invalid-field' : '')
  }, /*#__PURE__*/React.createElement(Password, passwordFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap ".concat(errorConfirmPassword ? 'invalid-field' : '')
  }, /*#__PURE__*/React.createElement(Password, confirmPasswordFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap ".concat(errorEmail ? 'invalid-field' : '', " ").concat(usernameAvailable ? 'valid-field' : '')
  }, /*#__PURE__*/React.createElement(FormField, emailFieldProps), emailAvailable && verifyCode && /*#__PURE__*/React.createElement(CheckedIcon, null), isSendOTP && isResendOTP && !verifyCode && /*#__PURE__*/React.createElement("button", {
    className: "dac-login-form__resend-otp d-none d-md-block",
    type: "button",
    onClick: function onClick() {
      sendVerifyCode(get(configuration, 'sendButton.jss.value.href'), true);
    }
  }, getDictionaryItem(dictionary, 'resendOtp')))), !verifyCode && /*#__PURE__*/React.createElement(React.Fragment, null, isSendOTP ? /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap ".concat(errorCodeOTP ? 'invalid-field' : '', " ").concat(codeOTP && !errorCodeOTP ? 'verified-otp-code' : '')
  }, /*#__PURE__*/React.createElement(FormField, codeOTPFieldProps), isSendOTP && isResendOTP && !verifyCode && /*#__PURE__*/React.createElement("button", {
    className: "dac-login-form__resend-otp d-md-none",
    type: "button",
    onClick: function onClick() {
      sendVerifyCode(get(configuration, 'sendButton.jss.value.href'), true);
    }
  }, getDictionaryItem(dictionary, 'resendOtp')))) : /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group lr__form-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-label visibility-hidden d-none d-md-block"
  }, get(configuration, 'sendButton.jss.value.text')), /*#__PURE__*/React.createElement("div", {
    className: "request-failed-wrap"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary dac-login-form__submit",
    disabled: isDisableOTP || validateLoader,
    type: "button",
    name: "SendOtpButton",
    onClick: function onClick() {
      sendVerifyCode(get(configuration, 'sendButton.jss.value.href'));
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: validateLoader ? 0 : 1
    }
  }, get(configuration, 'sendButton.jss.value.text')), validateLoader ? /*#__PURE__*/React.createElement(Loader, null) : false), valiadteError && /*#__PURE__*/React.createElement("b", {
    className: "request-failed"
  }, valiadteError)))))), /*#__PURE__*/React.createElement("div", {
    className: "form-elements dac-login-form__checkboxes"
  }, /*#__PURE__*/React.createElement(Checkboxes, checkboxesFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "dac-login-form__submit-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "request-failed-wrap"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary dac-login-form__submit",
    type: "submit",
    disabled: disableSubmit || Boolean(submitLoader)
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: Boolean(submitLoader) ? 0 : 1
    }
  }, get(configuration, 'registerAndLoginButton.jss.value.text')), Boolean(submitLoader) ? /*#__PURE__*/React.createElement(Loader, null) : false), submitError && /*#__PURE__*/React.createElement("b", {
    className: "request-failed"
  }, submitError)))), showModal && /*#__PURE__*/React.createElement(Modal, {
    hide: function hide() {
      return setShowModal(false);
    },
    dictionary: dictionary,
    rtl: rtl,
    title: get(configuration, 'invitationSectionTitle.jss.value'),
    description: get(configuration, 'invitationSectionDescription.jss.value') + " ".concat(email && "<b>".concat(email, "</b>")),
    children: /*#__PURE__*/React.createElement(RegistrationInvitationCode, {
      dictionary: dictionary,
      configuration: configuration,
      apiConfig: apiConfig,
      sessionId: sessionId,
      hide: function hide() {
        return setShowModal(false);
      },
      callAfterSubmit: callAfterSubmit,
      rtl: rtl,
      username: username,
      email: email
    })
  }));
};
var CheckedIcon = function CheckedIcon() {
  return /*#__PURE__*/React.createElement("div", {
    className: "ckecked-icon"
  }, /*#__PURE__*/React.createElement(IconVerified, null));
};
export default DacRegisterForm;
var commonStyles = "c4wze6j";
var ltrStyles = "l1avpxqa";
var rtlStyles = "r1oseorr";